import type { DefinitionBlockComponent, Reference, BlockComponent, CommonProperties } from "../survey";

export const ReferenceableBlocks = ['Attachment','Explanation','Select'] as const;
export type ReferenceableBlock = typeof ReferenceableBlocks[number];
export type ReferenceBlocks = `${typeof ReferenceableBlocks[number]} Reference`;
export const referenceBlocksArray: ReferenceBlocks[] = ReferenceableBlocks.map(b => `${b} Reference` as const);

export function replaceReferenceWithDefinition(reference: Reference & CommonProperties, definition: DefinitionBlockComponent): BlockComponent & { id: string } | null {
  // First check that the definition is the same kind as the reference and that the ids match
  if (reference.kind !== (definition.kind + ' Reference') || reference.definitionId !== definition.definitionProps.id) {
    console.error("Reference", reference, "is not the same kind as the definition", definition);
    return null;
  }
  return { 
    ...definition,
    id: reference.id,
    hidden: reference.hidden,
    optional: reference.optional,
  } satisfies (BlockComponent & { id: string })
}